import { faArrowRightLong } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BreadcrumbItem from 'Components/Atoms/BreadcrumbItem/BreadcrumbItem';
import Grid from 'Components/Atoms/Grid/Grid';
import Spinner from 'Components/Atoms/Spinner/Spinner';
import Title from 'Components/Atoms/Title/Title';
import Breadcrumbs from 'Components/Molecules/Breadcrumbs/Breadcrumbs';
import Card from 'Components/Molecules/Card/Card';
import TitleGroup from 'Components/Molecules/TitleGroup/TitleGroup';
import SettingsTemplate from 'Components/Templates/Page/Settings/SettingsTemplate';
import { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { ROUTES } from 'Services/Route/Route.types';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import { StoreState } from 'Store/Reducers';
import { fetchEntities } from 'Store/Settings/Entities/Actions';
import { getEntitiesById, isEntityLoading } from 'Store/Settings/Entities/Selectors';
import { faLayerGroup, faTableLayout } from '@fortawesome/pro-solid-svg-icons';
import { faChartSimpleHorizontal } from '@fortawesome/pro-solid-svg-icons';
import IconWrapper from 'Components/Atoms/IconWrapper/IconWrapper';
import EntityIcon from 'Components/Atoms/EntityIcon/EntityIcon';
import Text from 'Components/Atoms/Text/Text';

const SettingsMenu: any = [{
    path: ROUTES.SETTINGS.ENTITIES.ENTITY.LAYOUTS,
    icon: faTableLayout,
    title: 'Layout Management',
    description: 'Ga door naar de layout instellingen'
}, {
    path: ROUTES.SETTINGS.ENTITIES.ENTITY.FIELDS,
    icon: faChartSimpleHorizontal,
    title: 'Field management',
    description: 'Ga door naar de field instellingen'
}, {
    path: ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES,
    icon: faLayerGroup,
    title: 'Modules',
    description: 'Ga door naar de instellingen van modules'
}];

const EntitySettingsPage = ({
    entitiesById, isLoading,
    ...props
}: EntitySettingsPageProps) => {
    const { entity_id } = useParams();

    useEffect(() => {
        props.fetchEntities();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const entity = useMemo(() => {
        if (entity_id) {
            return {
                ...entitiesById?.[entity_id],
                formattedName: EntityHelper.getDisplayValueByName(entitiesById?.[entity_id]?.name)
            };
        }

        return {};
    }, [entitiesById, entity_id]);

    return <SettingsTemplate
        breadcrumbs={
            <Breadcrumbs>
                <BreadcrumbItem path={ROUTES.SETTINGS.path}>Instellingen</BreadcrumbItem>
                <BreadcrumbItem path={ROUTES.SETTINGS.ENTITIES.getFullPath()}>Entiteiten</BreadcrumbItem>
                <BreadcrumbItem>{entity?.formattedName || 'Oops...'}</BreadcrumbItem>
            </Breadcrumbs>
        }
        description={`Instellingen voor ${(entity?.formattedName || 'oops...')}`}
    >
            { isLoading &&
                <Grid position='centered'>
                    <Spinner />
                    <Title size='small' weight='semibold'>Entiteiten laden...</Title>
                </Grid>
            }
            { !isLoading
            && !entity?.id
            &&  <Grid position='centered'>
                    <Title size='small' weight='semibold'>Geen entiteit gevonden met de volgende id: {entity_id}</Title>
                </Grid>
            }
            { !isLoading
            && entity?.id
            && <Grid axis='vertical'>
                    <Link to={ROUTES.SETTINGS.ENTITIES.ENTITY.GENERAL.getFullPath(entity.id)} style={{textDecoration: 'none'}} key={entity.id} data-cy="entity-item">
                        <Card axis="horizontal" state="link">
                            <TitleGroup iconBefore={
                                <EntityIcon entity={entity.name} size='large' />
                            }>
                                <Title size="inherit" weight='bold' transform='uppercase'>{entity.formattedName}</Title>
                                <Text color='secondary'>Ga door naar de instellingen van {entity.formattedName}</Text>
                            </TitleGroup>
                            <FontAwesomeIcon icon={faArrowRightLong} size='2x' color='#757575' />
                        </Card>
                    </Link>
                    {
                        SettingsMenu.map((i: any) =>
                            <Link to={i.path.getFullPath(entity_id)} style={{textDecoration: 'none'}} key={entity_id} data-cy="entity-item">
                                <Card axis="horizontal" state="link">
                                    <TitleGroup iconBefore={
                                        <IconWrapper>
                                            <FontAwesomeIcon icon={i.icon} size="2x" />
                                        </IconWrapper>
                                    }>
                                        <Title
                                            size="inherit"
                                            transform='uppercase'
                                            weight='bold'
                                        >
                                            { i.title }
                                        </Title>
                                        <Text color='secondary'>{i.description}</Text>
                                    </TitleGroup>
                                    <FontAwesomeIcon icon={faArrowRightLong} size='2x' color='#757575' />
                                </Card>
                            </Link>
                        )
                    }
                </Grid>
            }
    </SettingsTemplate>
}

interface Props {

}

const mapState = (state: StoreState) => ({
    entitiesById: getEntitiesById(state),
    isLoading: isEntityLoading(state)
});

const mapDispatch = {
    fetchEntities
}

type EntitySettingsPageProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(EntitySettingsPage);